import React, { useEffect, useState } from "react";
import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  Label,
  Alert,
  Button,
  Col,
  Row,
} from "reactstrap";
import { Controller, useForm } from "react-hook-form";
import { AgGridColumn, AgGridReact } from "ag-grid-react";

import {
  SearchableSelectHookForm,
  TextFieldHookForm,
} from "../../../../../layout/HookFormInputs";
import {
  addAssignCft,
  addAssignCftSave,
  deleteAssifnCft,
  fetchAllAssignCftList,
  fetchViewDetailReport,
  getAssiginCftListingServices,
  getRegionListingServices,
} from "../../../Action";
import { useLocation } from "react-router-dom";
import { userDetails } from "../../../../../../helper";
import { useDispatch, useSelector } from "react-redux";
import Toaster from "../../../../../common/Toaster";
import LoaderCustom from "../../../../../common/LoaderCustom";
import DayTime from "../../../../../common/DayTimeWrapper";
import { defaultPageSize } from "../../../../../../config/constants";
import VersionListing from "./VersionListing";
import PopupMsgWrapper from "../../../../../common/PopupMsgWrapper";
import { getVendorListFormDetailById } from "../../../../VendorNeedList/Action";

const AssignCfts = ({ viewDataFromSupplier, auditStatusTab, deleteFlagCheck }) => {


  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [globalTake, setGlobalTake] = useState(defaultPageSize);
  const dataEmpId = userDetails();
  const EmpId = dataEmpId?.EmployeeId;

  const idData = searchParams.get("VendorRequirementRegistrationId");
  const nsaAuditDetailId = searchParams.get("nsaAuditDetailId");
  const [cftListing, setCftListing] = useState([]);
  const [regionListing, setRegionListing] = useState([]);
  const [lodingCft, setCftLoading] = useState(false);
  const dispatch = useDispatch();
  const [showVersioningListing, setShowVersioningListing] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [formData, setFormData] = useState(null);
  const { loading, assignCftList } = useSelector(
    (state) => state?.getAllAssignCftReducer
  );
  

  const [open, setOpen] = useState("1");
  const {
    register,
    handleSubmit,
    watch,
    clearErrors,
    setValue,
    trigger,
    getValues,
    reset,
    resetField,
    formState: { errors },
    control,
  } = useForm({
    defaultValues: {},
    mode: "onChange",
    reValidateMode: "onChange",
  });
  const [selectedAuditMethod, setSelectedAuditMethod] = useState(null);


  const handleRadioChange = (e) => {
    setSelectedAuditMethod(e.target.value);
  };
  const {
    register: registerController,
    handleSubmit: handleSubmitController,
    watch: watchontroller,
    clearErrors: clearErrorsController,
    setValue: setValueController,
    trigger: triggerController,
    getValues: getValuesController,
    reset: resetController,
    resetField: resetFieldController,
    formState: { errors: errorsController },
    control: controlController,
  } = useForm({
    defaultValues: {},
    mode: "onChange",
    reValidateMode: "onChange",
  });

  const getUsers = async (empId, cftId) => {
    try {
      // Set loading state to true to indicate data fetching
      setCftLoading(true);

      // Dispatch the action to fetch users
      await dispatch(
        fetchAllAssignCftList({
          empId,
          cftId,
          // SearchText: SearchText ? SearchText : "",
        })
      );

      // Reset loading state to false after the data is fetched
      setCftLoading(false);
    } catch (error) {
      // Handle errors, e.g., display an error message


      // Reset loading state to false in case of an error
      setCftLoading(false);
    }
  };
  const getUsersViewDetailReport = async (vendorRegId, nsaAuditDetailId) => {
    try {
      await dispatch(
        fetchViewDetailReport({
          vendorID: vendorRegId,
          nsaAuditDetailId: nsaAuditDetailId,
        })
      );
    } catch (error) {

    }
  };
  const onSubmitData = async (data) => {


    let empId = userDetails();
    try {
      setCftLoading(true); // Set loading to true during submission
      const payload = {
        VendorRequirementRegistrationId: parseInt(idData),
        NsaAuditDetailId: parseInt(nsaAuditDetailId),
        AuditMethod: parseInt(data?.VendorRelation),
        Reason: data?.region?.value
      };
      // Assuming dispatch is asynchronous, you can wait for it to complete using await
      const res = await new Promise((resolve) => {
        dispatch(addAssignCftSave(payload, resolve));
      });
      if (res && res?.IsSuccessful) {
        getUsers(parseInt(nsaAuditDetailId), parseInt(idData)); // Fetch updated data
        getUsersViewDetailReport(idData, nsaAuditDetailId)
        Toaster.success(res?.Data[0]?.Message);
        setValue("assignCFT", null);
      }
    } catch (error) {
      setCftLoading(false); // Set loading to false in case of an error
    } finally {
      setValue("assignCFT", " ");
      setCftLoading(false); // Ensure loading is set to false even if an error occurs
    }
  };

  const defaultColDef = {
    resizable: true,
    filter: true,
    sortable: false,

    // headerCheckboxSelection: (isSimulation || props?.benchMark) ? isFirstColumn : false,
    headerCheckboxSelectionFilteredOnly: true,
    // checkboxSelection: isFirstColumn
  };
  useEffect(() => {
    const fetchData = async () => {
      setCftLoading(true);
      await Promise.all([
        getAssignCftsListing(),
        getUsers(nsaAuditDetailId, idData),
        getRegionMasterListing(),
        getVendorListFormDetailById(idData)
      ]);
      setCftLoading(false);
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (assignCftList) {
      setValueController("VendorRelation", assignCftList?.auditMethod?.toString());
      setSelectedAuditMethod(assignCftList?.auditMethod?.toString());
      setValueController("region", assignCftList?.reason ? {
        value: assignCftList?.reason || "",
        label: assignCftList?.reasonName,
      } : null);
    }
  }, [assignCftList]);

  const getAssignCftsListing = () => {
    getAssiginCftListingServices(idData)
      .then((res) => {

        setCftListing(res);
      })
      .catch(() => { });
  };
  const getRegionMasterListing = () => {
    getRegionListingServices()
      .then((res) => {
        setRegionListing(res?.Data);
      })
      .catch(() => { });
  };
  const renderListing = (label) => {
    if (label === "assignCftList") {
      return cftListing.map((typeofEstablishment) => ({
        value: typeofEstablishment.Id,
        label: typeofEstablishment.Name,
      }));
    }
    if (label === "regionList") {
      return regionListing.map((typeofEstablishment) => ({
        value: typeofEstablishment.Id,
        label: typeofEstablishment.Name,
      }));
    }
  };

  const onSubmit = async (data) => {
    let empId = userDetails();
    try {
      setCftLoading(true); // Set loading to true during submission
      const payload = {
        VNFId: parseInt(idData),
        IsActive: true,
        IsAssignedCFT: true,
        AuditorAssignedToId: parseInt(data?.assignCFT?.value),
        AssignedBy: parseInt(empId?.EmployeeId),
        AssignCFTEmpId: parseInt(empId?.EmployeeId),
        IsMainAuditor: false,
        CreatedBy: parseInt(empId?.EmployeeId),
        NsaAuditDetailId: parseInt(nsaAuditDetailId),
      };
      // Assuming dispatch is asynchronous, you can wait for it to complete using await
      const res = await new Promise((resolve) => {
        dispatch(addAssignCft(payload, resolve));
      });
      if (res && res?.IsSuccessful) {
        getUsers(parseInt(nsaAuditDetailId), parseInt(idData)); // Fetch updated data
        Toaster.success(res?.Data[0]?.Message);
        //  getUsersViewDetailReport(idData, nsaAuditDetailId)
        setValue("assignCFT", null);
      }
    } catch (error) {
      setCftLoading(false); // Set loading to false in case of an error
    } finally {
      setValue("assignCFT", " ");
      setCftLoading(false); // Ensure loading is set to false even if an error occurs
    }
  };

  // if (lodingCft) {
  //   return (
  //     <div>
  //       {" "}
  //       <LoaderCustom customClass="simulation-Loader" />
  //     </div>
  //   ); // Render loading indicator if loading is true
  // }
  const effectiveDateFormatter = (props) => {
    const cellValue = props?.valueFormatted
      ? props.valueFormatted
      : props?.value;
    return cellValue != null ? DayTime(cellValue).format("DD/MM/YYYY") : "";
  };

  const buttonFormatter = (props) => {
    props.api.sizeColumnsToFit();
    const handleDeletePopup = () => {
      // Set loader to true to indicate delete operation is in progress
      setCftLoading(true);

      deleteAssifnCft(props?.data?.id, (error, response) => {
        // Set loader to false once the delete request is complete
        setCftLoading(false);

        if (error) {

          Toaster.error(error?.response?.data?.ErrorMessage);
          // Handle the error as needed
        } else {
          Toaster.success(response?.data?.Data?.Message);
          // Fetch updated data after deletion
          getUsers(parseInt(nsaAuditDetailId), parseInt(idData)); // Fetchw updated data
        }
      });
    };

    return (
      <div>
        {viewDataFromSupplier?.AssignAuditorID == EmpId && (
          <button
            title="Delete"
            className="Delete hl-delete-icon"
            type="button"
            onClick={handleDeletePopup}
          >
          </button>
        )}
      </div>
    );
  };
  const frameworkComponents = {
    totalValueRenderer: buttonFormatter,
    // customFloatingFilter: CustomDateRangeFilter,
    // statusButtonFormatter: statusButtonFormatter,
    // onFilterChanged: onFilterChanged,
    effectiveDateFormatter: effectiveDateFormatter,
    // hyphenFormatter: hyphenFormatter,
    // customNoRowsOverlay: NoContentFound,
    // checkBoxRenderer: checkBoxRenderer,
    // valuesFloatingFilter: SingleDropdownFloationFilter,
  };

  const toggle = (id) => {
    if (open === id) {
      setOpen();
    } else {
      setOpen(id);
    }
  };



  const onPopupConfirm = () => {
    setShowPopup(false);
    if (formData) {
      handleSubmitController(onSubmitData)();
    }
  };

  const handleSaveClick = async () => {
    const isValid = await triggerController();
    if (isValid) {
      setFormData(getValuesController());
      setShowPopup(true);
    }
  };
  const closePopUp = () => {
    setShowPopup(false);
  };
  return (
    <div>
      {lodingCft && <LoaderCustom customClass="simulation-Loader" />}
      <div>
        {auditStatusTab == 20 &&
          <Accordion
            open={open}
            toggle={toggle}
            className="pb-2"
            defaultOpen={["1"]}
            stayOpen
          >
            <AccordionItem>
              <AccordionHeader targetId={2} onClick={() => setShowVersioningListing(!showVersioningListing)}>
                <div className="header-title">
                  <h5>View History</h5>
                </div>
              </AccordionHeader>
              <AccordionBody accordionId={2}>
                {showVersioningListing && <VersionListing />}
              </AccordionBody>
            </AccordionItem>
          </Accordion>}
      </div>
      <Row className="mb-3">
        <Col md="3" offset="8">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="d-flex align-items-center">
              <SearchableSelectHookForm
                {...register("assignCFT", { required: "Please select an option" })}
                label={"Assign CFT"}
                name={"assignCFT"}
                placeholder={"Select"}
                Controller={Controller}
                control={control}
                rules={{ required: true }}
                options={renderListing("assignCftList")}
                handleChange={() => { }}
                errors={errors.assignCFT}
                mandatory={true}
                disabled={assignCftList?.addCft}
              />
              <div>
                {viewDataFromSupplier?.AssignAuditorID
                  == EmpId && auditStatusTab != 21 && auditStatusTab != 20 && auditStatusTab != 11 && !assignCftList?.addCft && (
                    <button
                      type="button"
                      className={"user-btn mr-2 mt-3 ms-2 mb-1"}
                      title="Add"
                      onClick={handleSubmit(onSubmit)}
                    >
                      <div className="plus mr-0"></div>
                    </button>
                  )}

              </div>
            </div>
          </form>
        </Col>
        <Col md="8">
          <form>
            <Row>
              <Col md="4" className="d-flex justify-content-center">
                <div>
                  <Label className="d-inline-block align-middle w-auto pl-0 pt-0">
                    Select Audit Method
                    <span className="asterisk-required">*</span>
                  </Label>
                  <div className="mt-2">
                    <Label
                      className="d-inline-block align-middle w-auto pl-2 pr-5 mr-5 pr-4 pt-0 radio-box"
                      check
                    >
                      <input
                        type="radio"
                        name="VendorRelation"
                        className="zero-based"
                        id="VendorRelationOffline"
                        disabled={assignCftList?.auditMethod != null}
                        value={2}
                        {...registerController("VendorRelation", { required: "This field is required" })}
                        onChange={handleRadioChange}
                      />
                      <span>Onsite</span>
                    </Label>
                    <Label
                      className="d-inline-block align-middle w-auto pl0 pt-0 radio-box"
                      check
                    >
                      <input
                        type="radio"
                        name="VendorRelation"
                        className="zero-based"
                        id="VendorRelationOnline"
                        disabled={assignCftList?.auditMethod != null}
                        value={1}
                        {...registerController("VendorRelation", { required: "This field is required" })}
                        onChange={handleRadioChange}
                      />
                      <span>Online</span>
                    </Label>
                  </div>
                  {errorsController.VendorRelation && <p className="text-help">{errorsController.VendorRelation.message}</p>}
                </div>
              </Col>
              {selectedAuditMethod == '1' && (
                <Col md="3">
                  <div>
                    <SearchableSelectHookForm
                      {...registerController("region", { required: "Please select an option" })}
                      label={"Select Reason"}
                      name={"region"}
                      placeholder={"Select"}
                      Controller={Controller}
                      control={controlController}
                      rules={{ required: true }}
                      customClassName="mb-0"
                      mandatory={true}
                      options={renderListing("regionList")}
                      handleChange={() => { }}
                      errors={errorsController.region}
                      disabled={assignCftList?.auditMethod != null}
                    />
                    {errorsController.region && <p className="text-help">{errorsController.region.message}</p>}
                  </div>
                </Col>
              )}


              <Col md="2" className="pt-3">
                {assignCftList?.auditMethod == null && viewDataFromSupplier?.AssignAuditorID == EmpId &&
                  <button
                    type="button"
                    className="submit-button save-btn ms-0 mb-0 mt-3"
                    onClick={handleSaveClick}
                  >
                    <div className="save-icon mr-1"></div>
                    {"Save"}
                  </button>
                }
              </Col>
              {assignCftList?.auditorname &&
                <Col md="3">
                  <label htmlFor="lead-auditor-name" className="form-label">
                    Lead Auditor
                  </label>
                  <input
                    type="text"
                    id="lead-auditor-name"
                    className="form-control"
                    value={assignCftList?.auditorname}
                    disabled
                  />
                </Col>
              }
            </Row>
          </form>
        </Col>
        <div>
          {showPopup && (
            <PopupMsgWrapper
              isOpen={showPopup}
              closePopUp={closePopUp}
              confirmPopup={onPopupConfirm}
              message={
                <>
                  Are you sure you want to save the audit method selection?
                  <br />
                  The selection cannot be undone later.
                </>
              }
            />
          )}
        </div>
      </Row >
      <Row className="ag-grid-react">
        <Col>
          <div className={`ag-grid-wrapper`}>
            <div className={`ag-theme-material`}>
              <AgGridReact
                style={{ height: "100%", width: "100%" }}
                floatingFilter={true}
                defaultColDef={defaultColDef}
                domLayout="autoHeight"
                rowData={assignCftList?.cftAuditorResponseModelLists}
                rowSelection={"multiple"}
                pagination={false}
                enableBrowserTooltips={true}
                frameworkComponents={frameworkComponents}
                // pagination={true}
                paginationPageSize={globalTake}
                pivotPanelShow={"always"}
                paginationAutoPageSize={true}
              >
                <AgGridColumn
                  headerName="S. No."
                  field="serialNumber"
                  floatingFilter={false}
                  sortable={false}
                  valueGetter={(params) => params.node.rowIndex + 1}
                ></AgGridColumn>

                <AgGridColumn
                  cellClass="has-checkbox"
                  field="employeeCode"
                  floatingFilter={false}
                  headerName="Employee Code"
                ></AgGridColumn>

                <AgGridColumn
                  field="employeeName"
                  floatingFilter={false}
                  headerName="Employee Name"
                ></AgGridColumn>

                <AgGridColumn
                  field="position"
                  floatingFilter={false}
                  headerName="Position"
                ></AgGridColumn>

                <AgGridColumn
                  headerName="Plant"
                  sortable={false}
                  field="plantName"
                  floatingFilter={false}
                ></AgGridColumn>

                <AgGridColumn
                  headerName="Added On"
                  sortable={false}
                  field="addedOnDate"
                  floatingFilter={false}
                  valueFormatter={(params) => {
                    const cellValue = params.value;
                    return cellValue
                      ? DayTime(cellValue).format("DD/MM/YYYY")
                      : "";
                  }}
                ></AgGridColumn>

                <AgGridColumn
                  headerName="Action"
                  sortable={false}
                  cellRenderer={"totalValueRenderer"}
                  type="rightAligned"
                  floatingFilter={false}
                ></AgGridColumn>
              </AgGridReact>
            </div>
          </div>
        </Col>
      </Row>
    </div >
  );
};

export default AssignCfts;
